import { render, staticRenderFns } from "./MagicCube.vue?vue&type=template&id=b56fd90a&"
import script from "./MagicCube.vue?vue&type=script&lang=js&"
export * from "./MagicCube.vue?vue&type=script&lang=js&"
import style0 from "./MagicCube.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports